class OptionsSaveController {

    constructor($rootScope, $state, $stateParams, access) {
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.access = access;
    }

    $onInit() {
        this.activeTab = this.$stateParams.tab || 'profile';
        if ( !this.option || Object.keys(this.option).length === 0 ) {
            this.option = {
                property_id: this.$rootScope.currentProperty.id
            };
        }
    }
}

OptionsSaveController.$inject = [ '$rootScope', '$state', '$stateParams', 'access' ];

export default OptionsSaveController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/controllers/options.save.controller.js